var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "peer_info"
  }, [_vm._m(0), _c('div', {
    staticClass: "canv_cont"
  }, [_c('canvas', {
    ref: "canv"
  })])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_c('h4', {
    staticClass: "meta_title"
  }, [_vm._v("AVAX Stake Distribution")]), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("by AvalancheGo Version")])]);
}]

export { render, staticRenderFns }